import React from 'react';
import { makeStyles } from "@material-ui/core/styles"
import { getTranslation } from "../scripts/getTranslation"
import { useStore } from "../teafuljs/store"
import SphereCategoryTitle from './SphereCategoryTitle';

const useStyles = makeStyles(theme => ({}))

export default () => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()
  return (
    <div>
      <SphereCategoryTitle key={"INT-CAT-01"} cat={"INT-CAT-01"} />
      <div>
        <p>{getTranslation(translations, language, "KeyPassages", "INT-P-01")}</p>
      </div>
      {/* <SphereCategoryTitle key={"INT-CAT-02"} cat={"INT-CAT-02"} />
      <div>
        <p>{getTranslation(translations, language, "KeyPassages", "INT-P-02")}</p>
      </div>
      <SphereCategoryTitle key={"INT-CAT-03"} cat={"INT-CAT-03"} />
      <div>
        <p>{getTranslation(translations, language, "KeyPassages", "INT-P-03")}</p>
      </div>
      <SphereCategoryTitle key={"INT-CAT-04"} cat={"INT-CAT-04"} />
      <div>
        <p>{getTranslation(translations, language, "KeyPassages", "INT-P-04")}</p>
      </div>
      <SphereCategoryTitle key={"INT-CAT-05"} cat={"INT-CAT-05"} />
      <div>
        <p>{getTranslation(translations, language, "KeyPassages", "INT-P-05")}</p>
      </div> */}
    </div>
  )
}